/**
 * Get the filename without the extension
 * @example testFilename.jpg => testFilename
 * @param filename string
 * @returns string
 */var removeFileExtension = function removeFileExtension(filename) {
  return filename.replace(/\.[^.]*$/, '') || filename;
};
export { removeFileExtension };